// extracted by mini-css-extract-plugin
export default {"customSwitchGrid":"styles__customSwitchGrid___TRd8f"};